import React, { useEffect, useRef, useState } from 'react';
import JSONEditor, { JSONEditorOptions } from 'jsoneditor';
import 'jsoneditor/dist/jsoneditor.css';

interface JSONEditorProps {
  initialData: any;
  onChange: (updatedData: any) => void;
}

const JSONEditorComponent: React.FC<JSONEditorProps> = ({ initialData, onChange }) => {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const editorRef = useRef<JSONEditor | null>(null);
  const [mode, setMode] = useState<'tree' | 'code' | 'text'>('code');

  useEffect(() => {
    if (containerRef.current) {
      const options: JSONEditorOptions = {
        mode: mode,
        onChange: () => {
          if (editorRef.current) {
            try {
              const updatedData = editorRef.current.get();
              onChange(updatedData);
            } catch (error) {
              console.error('Invalid JSON:', error);
            }
          }
        },
      };

      editorRef.current = new JSONEditor(containerRef.current, options);
      editorRef.current.set(initialData);
    }

    return () => {
      if (editorRef.current) {
        editorRef.current.destroy();
      }
    };
  }, [initialData, onChange, mode]);

  const handleModeChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setMode(event.target.value as 'tree' | 'code' | 'text');
  };

  return (
    <div>
      <div style={{ marginBottom: '10px' }}>
        <label htmlFor="mode-select">Mode: </label>
        <select id="mode-select" value={mode} onChange={handleModeChange}>
          <option value="tree">Tree</option>
          <option value="code">Code</option>
          <option value="text">Text</option>
        </select>
      </div>
      <div ref={containerRef} style={{ height: '400px' }} />
    </div>
  );
};

export default JSONEditorComponent;
